import {Suspense, useEffect} from 'react'
import {Outlet, useLocation} from "react-router-dom"
// import {useRTL} from '@hooks/useRTL'
// import {useSkin} from '@hooks/useSkin'
import {getUI} from "../redux/actions/UI";
import {useDispatch} from "react-redux";

const BlankLayout = () => {
    //const [isRtl, setIsRtl] = useRTL();
    //const [skin, setSkin] = useSkin();
    const location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getUI());
    }, [location])

    return (
        <div className='blank-page'>
            <Suspense fallback={null}>
                <Outlet/>
            </Suspense>
        </div>
    )
}

export default BlankLayout
